<template>
  <div class="download-pid-modal">
    <modal ref="modal" autoWidth closeButton :width="400" @closed="onClose">
      <div class="download-pid-modal__modal center">
        <div class="download-pid-modal__header-menu">
          <h2 class="download-pid-modal__header">{{title}}</h2>
        </div>
        <h4 class="download-pid-modal__target-name" :title="target.display_name">{{target.display_name}}</h4>
        <div v-if="load" class="center">
          <loading-dots></loading-dots>
        </div>
        <span v-else-if="!hasPidLists">No PID lists found for target!</span>
        <table v-else>
          <thead>
          <tr>
            <th class="checkbox"><input type="checkbox" @click="onSelectAll"/></th>
            <th>Filename</th>
            <th class="file-extension">Type</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="list in localPidLists">
            <td class="checkbox"><input type="checkbox" v-model="list.selected"/></td>
            <td>{{`${target.display_name}_${list.suffix}`}}</td>
            <td class="file-extension">{{getFileExtension(list.name)}}</td>
          </tr>
          </tbody>
        </table>
        <div class="download-pid-modal__button center">
          <action-button :disabled="!buttonClickable" color="success" @click.native="download" label="Download PID Lists" id="downloadPidListsBtn"></action-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import Modal from '@/components/common/modal'
  import SvgIcon from '@/components/common/svgIcon'
  import LoadingDots from '@/components/common/loaderDots'
  import ActionButton from '@/components/common/actionButton'
  import {RESET_TARGET_PID_LISTS} from '@/appLogic/targets/currentTarget/store/actions'
  import {downloadFile} from '@/api'
  import {cloneDeep} from 'lodash'

  export default {
    components: {
      Modal,
      SvgIcon,
      LoadingDots,
      ActionButton
    },
    props: {
      title: String,
      svg: Object
    },
    data () {
      return {
        load: false,
        localPidLists: []
      }
    },
    computed: {
      loading () {
        return this.$store.state.currentTarget.isLoading
      },
      pidLists () {
        return this.$store.getters.pidLists
      },
      target () {
        return this.$store.getters.currentTarget
      },
      showModal () {
        return this.$store.state.currentTarget.showDownloadPidListModal
      },
      hasPidLists () {
        return this.pidLists > []
      },
      buttonClickable () {
        return this.localPidLists.findIndex(l => l.selected) > -1
      },
      selectedPidLists () {
        return this.localPidLists.filter(l => l.selected)
      }
    },
    methods: {
      close () {
        this.$refs.modal.close()
      },
      open () {
        this.$refs.modal.open()
      },
      onClose () {
        this.localPidLists = []
        this.$store.dispatch(RESET_TARGET_PID_LISTS)
        this.close()
      },
      onSelectAll (e) {
        this.localPidLists = this.localPidLists.map(l => ({ ...l, selected: e.target.checked }))
      },
      getFileExtension (filename) {
        return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)
      },
      async download () {
        for (let l of this.selectedPidLists) {
          await downloadFile(l.downloadUrl, `${this.target.display_name}_${l.suffix}`)
        }
        this.onClose()
      }
    },
    watch: {
      showModal (value) {
        if (value) {
          this.open()
        }
      },
      pidLists (value) {
        if (value > []) {
          this.localPidLists = cloneDeep(value)
        }
        this.localPidLists.forEach(l => {
          // PID files were created with a non-standard name scheme, so this is a workaround to ensure the filename remains {year}_{month}.csv
          try {
            const regex = /year_month=([^&]+)(?=\/)/            // grab YYYY and MM values from object key
            const expected = /^\d{4}_\d{2}./                    // test if filename already matches expected YYYY_MM.csv schema
            const fileExt = this.getFileExtension(l.name)
            l.suffix = expected.test(l.name) ? l.name : `${l.key.match(regex)[1]}.${fileExt}`
          } catch (e) {
            l.suffix = l.name
          }
        })
      },
      loading (value) {
        this.load = value
      }
    }
  }
</script>

<style lang="scss">
  $currentTargetBackgroundColor: color('grays', 'almost-white');
  .download-pid-modal {
    .center {
      display: grid;
      justify-content: center;
      align-content: center;
    }
    .modal__content {
      background-color: $currentTargetBackgroundColor;
    }
    &__svg {
      float: left;
      margin-right: 20px;
    }
    &__button {
      margin: 20px;
    }
    &__header-menu {
      height: 100px;
      width: 100%;
    }
    &__header {
      float: left;
    }
    &__modal {
      > h4 {
        margin: 0 0 20px 0;
      }
      > table {
        table-layout: fixed;
        width: 100%;
      }
      tr {
        height: 30px;
      }
      th {
        background: #d3d3d3;
      }
      td {
        padding-left: 5px;
      }
      th.checkbox {
        width: 10%;
      }
      td.checkbox {
        padding: 0 0 5px 9px;
      }
      th.file-extension {
        width: 15%;
      }
      td, th {
        box-shadow: 0 0 0 1px;
        min-height: 24px;
      }
      @media (min-resolution: 2dppx) {
        td, th {
          box-shadow: 0 0 0 0.5px;
        }
      }
      @media (min-resolution: 3dppx) {
        td, th {
          box-shadow: 0 0 0 0.33333333px;
        }
      }
      @media (min-resolution: 4dppx) {
        td, th {
          box-shadow: 0 0 0 0.25px;
        }
      }
    }

    &__target-name {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// DownloadPidListModal.vue?251db9e2